import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Grid, IconButton, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const ModalPassword = (props) => {
    const {
        register,
        formState: { errors },
        getValues
    } = useFormContext();
    const [esPass, setEsPass] = useState({ pass1: true, pass2: true });
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label="Nueva Contraseña"
                    name="pass"
                    size="small"
                    type={esPass.pass1 == true ? 'password' : 'text'}
                    {...register('pass', {
                        required: { value: true, message: 'Campo requerido' },
                        validate: (value) => value.length >= 6 || 'Mínimo 6 caracteres'
                    })}
                    error={errors?.pass}
                    helperText={errors?.pass?.message}
                />
                <IconButton onClick={() => setEsPass({ ...esPass, pass1: !esPass.pass1 })}>
                    {esPass.pass1 == true ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Confirme contraseña"
                    name="pass2"
                    size="small"
                    type={esPass.pass2 == true ? 'password' : 'text'}
                    {...register('pass2', {
                        required: { value: true, message: 'Campo requerido' },
                        validate: (value) => value == getValues('pass') || 'Las contraseñas no coinciden'
                    })}
                    error={errors?.pass2}
                    helperText={errors?.pass2?.message}
                />
                <IconButton onClick={() => setEsPass({ ...esPass, pass2: !esPass.pass2 })}>
                    {esPass.pass2 == true ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default ModalPassword;
